import React from "react";
import BarChartAVkW from "../charts/BarChartAVkW";
import "./home.css";

const Chart = () => {
  return (
    <section className='home'>
      <div className='container'>
        <div className='heading flexSB'>
          <div className="flex items-center">            
          </div>
        </div>
        <BarChartAVkW />
      </div>
    </section>
  );
}

export default Chart;
